/**
 * 클립보드 복사 — navigator.clipboard 는 보안 컨텍스트(HTTPS 또는 localhost)에서만 있다.
 * http://192.168.0.5:3001 처럼 LAN 주소로 열면 없으므로 숨김 textarea + execCommand('copy') 로 폴백한다.
 * 성공하면 true, 두 방법 다 실패하면 false.
 */
export async function copyText(text: string): Promise<boolean> {
  try {
    if (typeof navigator !== 'undefined' && navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(text);
      return true;
    }
  } catch { /* 권한 거부 등 → 폴백 */ }
  try {
    const ta = document.createElement('textarea');
    ta.value = text;
    ta.setAttribute('readonly', '');
    ta.style.position = 'fixed'; ta.style.top = '0'; ta.style.left = '0'; ta.style.opacity = '0';
    document.body.appendChild(ta);
    ta.focus(); ta.select(); ta.setSelectionRange(0, text.length);
    const ok = document.execCommand('copy');
    document.body.removeChild(ta);
    return ok;
  } catch {
    return false;
  }
}
